import { Box, Typography } from "@mui/material";
import { memo } from "react";

export const SpotPopupContent = memo(({ spot, config }) => {
    const popupFields = config.popupFields || {};
    const details = popupFields.details;

    return (
        <Box sx={{ minWidth: 200, fontSize: "0.85rem" }}>
            <Typography variant="subtitle2" sx={{ fontWeight: "bold", mb: 1 }}>
                {spot[popupFields.title]}
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                {popupFields.showLocal !== false && popupFields.local && (
                    <Typography variant="caption">
                        <strong>Local:</strong> {spot[popupFields.local]}
                    </Typography>
                )}

                {popupFields.bairro && (
                    <Typography variant="caption">
                        <strong>Bairro:</strong> {spot[popupFields.bairro]}
                    </Typography>
                )}

                {popupFields.logradouro && (
                    <Typography variant="caption">
                        <strong>Logradouro:</strong> {spot[popupFields.logradouro]}
                    </Typography>
                )}

                {details?.codigo && (
                    <Typography variant="caption">
                        <strong>Código:</strong> {spot[details.codigo] || "Não informado"}
                    </Typography>
                )}

                {details?.total && (
                    <Typography variant="caption">
                        <strong>Total:</strong>{" "}
                        {spot[details.total] != null
                            ? Number(spot[details.total]).toLocaleString("pt-BR")
                            : "Não informado"}
                    </Typography>
                )}

                {details?.percentual && (
                    <Typography variant="caption">
                        <strong>Porcentagem:</strong>{" "}
                        {spot[details.percentual] != null
                            ? `${Number(spot[details.percentual]).toLocaleString("pt-BR")}%`
                            : "Não informado"}
                    </Typography>
                )}

                {details?.coordenadas && (
                    <Typography variant="caption">
                        <strong>Coordenadas:</strong>{" "}
                        {spot.latitude}, {spot.longitude}
                    </Typography>
                )}
            </Box>
        </Box>
    );
});

SpotPopupContent.displayName = "SpotPopupContent";